<div class="page-wrapper">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12">
        <div class="login-card">
          <div>
            <div>
              <a class="logo" routerLink="/">
                <img
                  class="img-fluid for-light"
                  style="height: 201px; margin-bottom: -93px;"
                  src="assets/images/logo/login.png"
                  alt="loginpage"
                />
                <img
                  class="img-fluid for-dark"
                  style="height: 201px; margin-bottom: -93px;"
                  src="assets/images/logo/logo_dark.png"
                  alt="loginpage"
                />
              </a>
            </div>
            <div class="login-main">
              <h4>Reset Your Password</h4>

              <!-- Email Form -->
              <form
                *ngIf="!isEmailSent && !isOtpVerified"
                [formGroup]="emailForm"
                class="theme-form"
              >
                <div class="form-group">
                  <label class="col-form-label">Enter Your Email</label>
                  <input
                    class="form-control mb-1"
                    type="email"
                    placeholder="Enter Your Email"
                    formControlName="email"
                  />
                </div>
                <button
                  class="btn btn-primary btn-block m-t-10"
                  type="button"
                  [disabled]="emailForm.invalid"
                  (click)="sendEmail()"
                >
                  Send
                </button>
              </form>

              <!-- OTP Form -->
              <form
                *ngIf="isEmailSent && !isOtpVerified"
                [formGroup]="otpForm"
                class="theme-form"
              >
                <div class="form-group">
                  <label class="col-form-label">Enter OTP</label>
                  <input
                    class="form-control mb-1"
                    type="text"
                    placeholder="Enter Your OTP"
                    formControlName="otp"
                  />
                </div>
                <button
                  class="btn btn-primary btn-block m-t-10"
                  type="button"
                  [disabled]="otpForm.invalid"
                  (click)="verifyOtp()"
                >
                  Verify
                </button>
              </form>

              <!-- Password Reset Form -->
              <form
                *ngIf="isOtpVerified"
                [formGroup]="passwordForm"
                class="theme-form"
              >
                <div class="form-group">
                  <label class="col-form-label">New Password</label>
                  <input
                    class="form-control"
                    [type]="show ? 'text' : 'password'"
                    placeholder="New Password"
                    formControlName="password"
                  />
                  <div
                    class="show-hide"
                    (click)="togglePasswordVisibility()"
                  >
                    <span *ngIf="!show" class="show"></span>
                    <span *ngIf="show" class="hide"></span>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">Confirm Password</label>
                  <input
                    class="form-control"
                    type="password"
                    placeholder="Confirm Password"
                    formControlName="confirm_password"
                  />
                </div>
                <button
                  class="btn btn-primary btn-block"
                  type="button"
                  [disabled]="passwordForm.invalid"
                  (click)="resetPassword()"
                >
                  Reset Password
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
